// extracted by mini-css-extract-plugin
export default {"container":"J2-z","heading":"K2-z","links":"L2-z","copy":"M2-z","subCopy":"N2-z","linksLeft":"O2-z","linksCenter":"P2-z","linksRight":"Q2-z","link":"R2-z","onlyLink":"S2-z"};